import React, { useEffect } from 'react';
import { Field, Formik } from 'formik';
import * as Yup from 'yup';
import { connect } from 'react-redux';

import * as actions from '../../../Store/Actions';
import {
  AuthCard,
  AuthDescription,
  AuthFooter,
  AuthKicker,
  AuthLink,
  AuthPage,
  AuthTitle,
} from '../../../Components/Auth/AuthLayout';
import { StyledForm } from '../../../Hoc/elements';
import Input from '../../../Components/UI/Forms/Inputs/Input';
import Button from '../../../Components/UI/Forms/Button/Button';
import Message from '../../../Components/UI/Messages/Message';

const RecoverSchema = Yup.object().shape({
  email: Yup.string().email('Adresse e-mail invalide.').required('Votre adresse e-mail est requise.'),
});

const RecoverPassword = ({ cleanUp, error, loading, sendEmail }) => {
  useEffect(() => cleanUp, [cleanUp]);

  return (
    <AuthPage>
      <Formik
        initialValues={{ email: '' }}
        validationSchema={RecoverSchema}
        validateOnMount
        onSubmit={async (values, { setSubmitting }) => {
          await sendEmail(values);
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, isValid }) => (
          <AuthCard>
            <AuthKicker>Récupération du compte</AuthKicker>
            <AuthTitle>Réinitialisez votre mot de passe</AuthTitle>
            <AuthDescription>
              Saisissez l’adresse utilisée lors de votre inscription. Nous vous enverrons un lien sécurisé.
            </AuthDescription>
            <StyledForm noValidate>
              <Field
                type="email"
                name="email"
                label="Adresse e-mail"
                placeholder="vous@exemple.fr"
                autoComplete="email"
                component={Input}
              />
              <Button disabled={!isValid || isSubmitting} loading={loading ? 'Envoi du lien…' : null} type="submit">
                Envoyer le lien de réinitialisation
              </Button>
              <Message error show={Boolean(error)}>{error}</Message>
              <Message success show={error === false}>
                Le lien de réinitialisation a été envoyé. Pensez à vérifier vos courriers indésirables.
              </Message>
              <AuthFooter>
                <AuthLink to="/login">Retour à la connexion</AuthLink>
              </AuthFooter>
            </StyledForm>
          </AuthCard>
        )}
      </Formik>
    </AuthPage>
  );
};

const mapStateToProps = ({ auth }) => ({
  loading: auth.recoverPassword.loading,
  error: auth.recoverPassword.error,
});
const mapDispatchToProps = { sendEmail: actions.recoverPassword, cleanUp: actions.cleanMessage };

export default connect(mapStateToProps, mapDispatchToProps)(RecoverPassword);
